<app-field
  [focused]="focused"
  [dirty]="!empty"
  [disabled]="disabled"
  [showErrorEnabled]="showErrorEnabled"
>
  <label label *ngIf="!!label">{{ label }}</label>

  <input
    field
    #inputEl
    [ngxMatDatetimePicker]="picker"
    [max]="max"
    [formControl]="formControl"
    [name]="name ?? ''"
    [placeholder]="placeholder ?? ''"
    [readonly]="!!readOnly"
    (focus)="onFocusChanged(true)"
    (blur)="onFocusChanged(false)"
    (input)="onInputValue($event)"
    (keydown)="onInputKeydown($event)"
  />

  <ngx-mat-datetime-picker
    #picker
    [showSpinners]="true"
    [showSeconds]="true"
    [enableMeridian]="false"
    [hideTime]="!(type === 'datetime')"
  >
  </ngx-mat-datetime-picker>

  <app-button
    appFieldSuffix
    *ngIf="!!showClearButton && !!value"
    buttonType="normal"
    styleType="text"
    shapeType="circle"
    sizeType="x-small"
    icon="assets/icons/xmark.svg"
    (click)="onBtnClearClick($event)"
  ></app-button>

  <app-button
    appFieldSuffix
    *ngIf="!!showPickerIndicator"
    buttonType="primary"
    styleType="text"
    shapeType="circle"
    sizeType="x-small"
    icon="assets/icons/calendar-day.svg"
    (click)="onBtnPickerIndicatorClick($event)"
  ></app-button>

  <ng-container appFieldSuffix>
    <ng-content select="[appFieldSuffix]"></ng-content>
  </ng-container>
</app-field>
